/**
 * Skip LearnDash's "Start Quiz" interstitial (operator ruling, 2026-08-19).
 *
 * The start screen carries no information — breadcrumb, title, one button —
 * so arriving from the last topic cost an extra click on a near-empty page.
 *
 * This CLICKS LearnDash's own start control rather than bypassing it, so the
 * attempt record, timer and nonce all initialise exactly as they do normally.
 * If the button is absent (quiz locked after a pass, lessons-before-quiz gate
 * showing, or LD markup changed), nothing happens — the page is left alone.
 */
export function initQuizAutostart() {
  const root = document.querySelector('.wpProQuiz_content');
  if (!root) return;

  // Never auto-start over one of our own gate panels.
  if (document.querySelector('.bnrmp-quiz-locked, .bnrmp-quiz-gate')) return;

  const start = root.querySelector('input[name="startQuiz"], .wpProQuiz_button[name="startQuiz"]');
  if (!start || start.offsetParent === null) return;

  /* LearnDash binds the start handler from its own script, which runs after
     DOMContentLoaded. Clicking before that bind is a no-op, so wait for the
     window load event and then poll briefly for jQuery to have attached a
     handler. Bounded at ~2s so a change in LD never leaves this spinning. */
  const fire = () => {
    let tries = 0;
    const tick = () => {
      if (start.offsetParent === null) return;          // already started
      const $ = window.jQuery;
      const bound = $ && $._data && $._data(start, 'events');
      if (bound || tries > 20) { start.click(); return; }
      tries += 1;
      setTimeout(tick, 100);
    };
    tick();
  };

  if (document.readyState === 'complete') fire();
  else window.addEventListener('load', fire, { once: true });
}
